import React, { CSSProperties, useEffect, useState } from 'react'
import Lottie from 'react-lottie'
// import { fileMapping, loadAsset } from '@utilities/assetUtilities'
import './Loader.scss'

interface LoaderProps {
    message?: string
}

const Loader: React.FC<LoaderProps> = ({ message }) => {
    const [loaderAsset, setLoaderAsset] = useState(null)

    useEffect(() => {
        // Load the asset only if loaderAsset state is null
        // if (loaderAsset === null) {
        //     const fetchAsset = async () => {
        //         const response = await loadAsset(fileMapping.loader)
        //         setLoaderAsset(response)
        //     }
        //     fetchAsset()
        // }
    }, [])

    const MessageText = ({ style }: { style: CSSProperties }) => (
        <div className="message-text" style={style}>
            {message}
        </div>
    )

    return (
        <div
            className="loader-screen-section"
            data-testid="loader-screen-section">
            <MessageText
                style={{
                    opacity: 1,
                    visibility: 'visible',
                }}
            />
            <div
                className="loader-screen-animation"
                data-testid="loader-lottie-animation">
                <Lottie
                    options={{
                        loop: false,
                        autoplay: true,
                        animationData: loaderAsset,
                    }}
                />
            </div>
        </div>
    )
}

export default Loader
